import React from 'react';
import Styles from './LoadingWheel.module.scss';
import SpinnerImage from '../../Assets/Loaders/spinner.svg';

const LoadingWheel = (props) => {
  const { color } = props;
  const spinnerColor = {
    light: Styles.colorLight,
    dark: Styles.colorDark,
  };

  return (
    <div className={Styles.loadingWindow}>
      <img className={`${spinnerColor[color?.toLowerCase()]}`} src={SpinnerImage} title="Loading Wheel" alt="Loading Wheel"/>
    </div>
  );
};

export default LoadingWheel;
